    export const gridLayoutType = "Api.Core.EF.CommonModel.GridLayout";
    export const gridLayoutSelectorType = "Api.Core.EF.CommonModel.GridLayoutSelector";
    export const recentSearchesKey = "user_grid_recent_searches";
